import "../assets/Back.css";
import { defineComponent as _, useCssVars as r, computed as t, ref as g, watch as f, openBlock as n, createElementBlock as s, createElementVNode as d, createCommentVNode as k } from "vue";
import { l as p } from "./useStore.Ct_0CDaW.js";
const h = { class: "thn--tool-back" }, v = /* @__PURE__ */ d("div", { class: "thn--tool-back__color" }, null, -1), b = ["image-loaded"], B = ["alt", "src"], L = /* @__PURE__ */ _({
  __name: "Back",
  setup(y) {
    r((o) => ({
      "3a295ff2": m.value
    }));
    const e = p(), m = t(() => e != null && e.rtl ? "scaleX(-1)" : "none"), a = g(!1), c = t(() => e == null ? void 0 : e.styles.backgroundImage), i = t(() => e == null ? void 0 : e.styles.backgroundImageAlt);
    function u() {
      a.value = !0;
    }
    return f(() => e == null ? void 0 : e.styles.backgroundImage, (o, l) => {
      l !== o && (a.value = !1);
    }), (o, l) => (n(), s("div", h, [
      v,
      c.value ? (n(), s("div", {
        key: 0,
        "image-loaded": a.value,
        class: "thn--tool-back__image"
      }, [
        d("img", {
          onLoad: u,
          alt: i.value,
          src: c.value
        }, null, 40, B)
      ], 8, b)) : k("", !0)
    ]));
  }
});
export {
  L as _
};
//# sourceMappingURL=Back.vue_vue_type_style_index_0_lang.DFbYiUAW.js.map
